/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-07-20 23:51:19
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\utils\array.ts
 */
/**
 * 数组合并并去重
 * @param arr1 数组1
 * @param arr2 数组2
 */
export function mergeUnique<T>(arr1: Array<T>, arr2: Array<T>): Array<T> {
  const arr: Array<T> = arr1;
  for (let index = 0, len = arr2.length; index < len; index += 1) {
    if (!arr.includes(arr2[index])) {
      arr.push(arr2[index]);
    }
  }

  return arr;
}

/**
 * 数组去重
 * @param arr 数组
 */
export function unique<T>(arr: Array<T>): Array<T> {
  const array: Array<T> = [];
  for (let index = 0, len = arr.length; index < len; index += 1) {
    if (!array.includes(arr[index])) {
      array.push(arr[index]);
    }
  }
  return array;
}

/**
 * 获取地区地址
 */
export function arealistFn(arr:any,type:any){
  let list:Array<object> = []
  if(type == 1){
    arr.forEach((item:any) => {
      if(item?.children?.length > 0){
        list.push({
          value: item.label,
          label: item.label,
          children: arealistFn(item.children,type)
        })
      }else{
        list.push({
          value: item.label,
          label: item.label,
          children: []
        })
      }
    })
  }else{
    arr.forEach((item:any) => {
      if(item?.children?.length > 0){
        list.push({
          value: item.labelEn,
          label: item.labelEn,
          children: arealistFn(item.children,type)
        })
      }else{
        list.push({
          value: item.labelEn,
          label: item.labelEn,
          children: []
        })
      }
    })
  }

  return list
}
